<template>
    <div
        v-if="!users || $route.query.page > users.last_page"
        class="box-body with-border clearfix"
    >
        <p>There are no users in the system</p>
    </div>
    <div v-else>
        <div
            v-if="users.total"
            class="box-body with-border clearfix"
        >
            <BadgeTotal
                :value="users.total"
                color="gray"
                :label="`${$t('total')}: `"
            />

            <div
                class="pagination-box"
                @click="preventEnter"
                @keydown="preventEnter"
            >
                <pagination
                    :class="isDisabled()"
                    :data="users"
                    :limit="$root.paginator.settings.limit"
                    :size="$root.paginator.settings.size"
                    class="pull-right no-margin vue-pagination"
                    showDisabled
                    @pagination-change-page="getData"
                >
                    <span slot="prev-nav">
                        <i class="fa fa-angle-double-left"></i>
                    </span>
                    <span slot="next-nav">
                        <i class="fa fa-angle-double-right"></i>
                    </span>
                </pagination>
            </div>
        </div>
        <div class="box-body table-responsive no-padding">
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Avatar</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th v-if="withCompany">Company</th>
                        <th class="text-center">Active</th>
                        <th class="text-center">TFA enabled</th>
                        <th>Role</th>
                        <th class="text-right">Created At</th>
                        <th class="text-right">Updated At</th>
                        <th
                            v-if="isAdmin"
                            class="text-right"
                        >
                            Pswd Updated At
                        </th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="user in users.data"
                        :key="user.id"
                    >
                        <td>{{ user.id }}</td>
                        <td>
                            <div class="user-block">
                                <img
                                    :src="user.avatar"
                                    class="img-circle img-bordered-sm"
                                />
                            </div>
                        </td>
                        <td>{{ user.name }}</td>
                        <td>{{ user.email }}</td>
                        <td v-if="withCompany">
                            <div v-if="!user.company">
                                <em class="text-danger">None</em>
                            </div>
                            <div v-else>
                                <a :href="getRouteCompany(user.company.id)">
                                    {{ user.company.name }}
                                    <span
                                        v-if="user.owner"
                                        class="text-info"
                                        title="Owner"
                                    >
                                        <i class="fa fa-briefcase"></i>
                                    </span>
                                </a>
                            </div>
                        </td>
                        <td class="text-center">
                            <ValueYesNo :value="user.active"></ValueYesNo>
                        </td>
                        <td class="text-center">
                            <ValueYesNo :value="user.tfa_enabled"></ValueYesNo>
                        </td>
                        <td>
                            <GetRoleAndColor
                                :roleId="user.roles[0].id"
                                :roleName="user.roles[0].name"
                            ></GetRoleAndColor>
                        </td>
                        <td class="text-right">{{ user.created_at }}</td>
                        <td class="text-right">{{ user.updated_at }}</td>
                        <td
                            v-if="isAdmin"
                            class="text-right"
                        >
                            <ValueEmpty :value="user.pswd_updated_at"></ValueEmpty>
                        </td>

                        <td class="text-right">
                            <a
                                v-if="user.is_editable"
                                :href="getRouteEdit(user.id)"
                                class="btn btn-sm btn-primary"
                            >
                                <i class="fa fa-edit"></i>
                                <span class="sr-only">Edit</span>
                            </a>
                            <a
                                :href="getRouteShow(user.id)"
                                class="btn btn-sm btn-info"
                            >
                                <i class="fa fa-eye"></i>
                                <span class="sr-only">Show</span>
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="box-footer clearfix">
                <div
                    class="pagination-box"
                    @click="preventEnter"
                    @keydown="preventEnter"
                >
                    <pagination
                        :class="isDisabled()"
                        :data="users"
                        :limit="$root.paginator.settings.limit"
                        :size="$root.paginator.settings.size"
                        class="pull-right no-margin vue-pagination"
                        showDisabled
                        @pagination-change-page="getData"
                    >
                        <span slot="prev-nav">
                            <i class="fa fa-angle-double-left"></i>
                        </span>
                        <span slot="next-nav">
                            <i class="fa fa-angle-double-right"></i>
                        </span>
                    </pagination>
                </div>
            </div>
        </div>
    </div>
    <!-- /.box-body -->
</template>

<script>
import ValueEmpty from '../../subcomponents/ValueEmpty';
import ValueYesNo from '../../subcomponents/ValueYesNo';
import GetRoleAndColor from '../../subcomponents/GetRoleAndColor';
import BadgeTotal from '../../subcomponents/BadgeTotal';

export default {
    components: {
        ValueEmpty,
        ValueYesNo,
        GetRoleAndColor,
        BadgeTotal,
    },
    data() {
        return {
            users: {},
            isAdmin: false,
            showDisabled: 'show-disabled',
            disablePagination: true,
            withCompany: this.$attrs['setCompany'] ? this.$attrs['setCompany'] : false,
            pageNumber: this.$route.query.page,
        };
    },
    mounted() {
        this.getData(this.pageNumber);
    },
    methods: {
        preventEnter: function (event) {
            if (this.disablePagination) {
                return event.preventDefault();
            }
        },
        getData(page = 1) {
            this.disablePagination = true;
            axios
                .get(
                    '/users/index-data?page=' + page,
                    this.$router
                        .push({
                            path: this.$route.path,
                            query: {
                                page: page,
                            },
                            name: 'users.list.table',
                        })
                        .catch(() => {})
                )
                .then((response) => {
                    this.users = response.data.users;
                    this.isAdmin = response.data.isAdmin;
                    this.disablePagination = false;
                })
                .catch(() => {});
        },
        getRouteCompany: function (companyID) {
            return this.$attrs['route-company'].replace(':companyId:', companyID);
        },
        getRouteShow: function (id) {
            return this.$attrs['route-show'].replace(':id:', id);
        },
        getRouteEdit: function (id) {
            return this.$attrs['route-edit'].replace(':id:', id);
        },
        isDisabled: function () {
            return this.disablePagination ? 'disabled-box' : '';
        },
    },
};
</script>
